<template>
  <Button color="transparent" icon="Instagram" target="_blank" to="https://www.instagram.com/hengeloserevue/" />
  <Button color="transparent" icon="Facebook" target="_blank" to="https://www.facebook.com/profile.php?id=100057511687101&locale=nl_NL" />
</template>
